import { isElectron } from '@/utils/electron'
import Vue from 'vue'
import VueI18n from 'vue-i18n'

import en from './en.json'
import tc from './tc.json'
import sc from './sc.json'

Vue.use(VueI18n)

export function getUserLocale(): string {
  // get user locale
  let locale = null

  if (window.ipcRenderer || isElectron()) {
    locale = window.ipcRenderer.sendSync('get-user-locale')
  } else {
    locale = localStorage.getItem('locale')
  }

  if (locale) {
    return locale
  }

  // fallback to browser preferred locale
  const userLanguage = navigator.language || 'zh-TW'

  switch (userLanguage) {
    case 'zh-HK':
    case 'zh-TW':
    case 'zh-MO':
      locale = 'zh'
      break
    case 'zh-SG':
    case 'zh-CN':
      locale = 'zh-CN'
      break
    // case 'ja':
    //   locale = 'jp'
    //   break
    // case 'ko':
    //   locale = 'kr'
    //   break
    default:
      locale = 'en'
      break
  }

  return locale
}

export function setUserLocale(locale: string) {
  i18n.locale = locale
  if (isElectron()) {
    window.ipcRenderer.send('set-user-locale', locale)
  } else {
    localStorage.setItem('locale', locale)
  }
}

const i18n = new VueI18n({
  locale: getUserLocale(),
  messages: { en, zh: tc, 'zh-CN': sc },
  fallbackLocale: 'en'
})

export default i18n
